import React, { useEffect, useState } from 'react'
import { useAppData } from '../../../../../../context/AppDataContext'
import moment from 'moment';
import { Link } from 'react-router-dom';
import taskActivityServices from '../../../tasks/taskActivityServices';
import TaskDetails from '../../../tasks/components/TaskDetails';
import projectLocationServices from '../../projectLocationServices';
import { useAlert } from '../../../../../../context/AlertContext';
import { CircularProgress } from '@mui/material';
import projectActivityServices from '../../projectActivityServices';

const NotesDetails = ({activity,userDetails})=>{
    return(
        <>
            <div className='card-header'><span className='fw-bold text-success'> {userDetails.firstName} {userDetails.lastName} </span> added a note <span className='fw-bold text-primary'>{moment(activity.created_at).format("dddd, LLL")}</span> </div>
            <div className='card-body'>{activity.note.note}</div>
        </>
    )
}

const PoGenerated = ({activity,userDetails})=>{
    return(
        <>
            <div className='card-header'><span className='fw-bold'> {userDetails.firstName} {userDetails.lastName} </span> generated po for this project on <span className='fw-bold text-primary'>{moment(activity.created_at).format("dddd, LLL")}</span> </div>
            <div className='card-body'><Link className='btn btn-outline-primary' to={"/po/details/"+activity.refId}>View Po Details</Link></div>
        </>
    )
}

const PoUpdated = ({activity,userDetails})=>{
    return(
        <>
            <div className='card-header'><span className='fw-bold'> {userDetails.firstName} {userDetails.lastName} </span> updated po <span className='fw-bold text-primary'>{moment(activity.created_at).format("dddd, LLL")}</span> </div>
            <div className='card-body'><Link className='btn btn-outline-primary' to={"/po/details/"+activity.refId}>View Po Details</Link></div>
        </>
    )
}

const TaskCreated = ({activity,userDetails})=>{
    return(
        <>
            <div className='card-header'><span className='fw-bold'> {userDetails.firstName} {userDetails.lastName} </span> created a task on <span className='fw-bold text-primary'>{moment(activity.created_at).format("dddd, LLL")}</span> </div>
            <div className='card-body'><TaskDetails taskId={activity.refId} /></div>
        </>
    )
}

const TaskUpdated = ({activity,userDetails})=>{
    return(
        <>
            <div className='card-header'><span className='fw-bold'> {userDetails.firstName} {userDetails.lastName} </span> updated task on <span className='fw-bold text-primary'>{moment(activity.created_at).format("dddd, LLL")}</span> </div>
            <div className='card-body'><TaskDetails taskId={activity.refId} /></div>
        </>
    )
}

const TaskStatusUpdate = ({activity,userDetails}) => {

    const {getMasterLabel} = useAppData();
    const [activityDetails,setActivityDetails] = useState(null)
    const getACtivityDetails = () =>{
        taskActivityServices.getById(activity.refId).then(res=>{
            setActivityDetails(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }

    useEffect(()=>{
        getACtivityDetails()
    },[activity])

    return(
        activityDetails &&
        <>
            
            <div className='card-header'>
                <span className='fw-bold text-success'> {userDetails.firstName} {userDetails.lastName} </span> 
                updated progress of 
                <span className='fw-bold text-white bg-dark p-2 mx-2 rounded'>{activityDetails?.title}</span>
                on 
                <span className='fw-bold text-primary mx-2'>{moment(activity.created_at).format("dddd, LLL")}</span>
            </div>
            
            <div className='card-body'>
                <table className='table table-striped'>
                    <tbody>
                        <tr>
                            <th>Status</th>
                            <td>{getMasterLabel("task-status",activityDetails.taskId)}</td>
                        </tr>
                        <tr>
                            <th>Progress</th>
                            <td>{activityDetails.progress} %</td>
                        </tr>
                        {activityDetails.remark !== "" &&
                            <tr>
                                <th>Remark</th>
                                <td>{activityDetails.remark}</td>
                            </tr>
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={2}>
                                <div className='card-body'><TaskDetails taskId={activityDetails.taskId} /></div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            {/*
            <div className='card-body'>
                {JSON.stringify(activity)}
                <br/>
                {JSON.stringify(activityDetails)}
            </div>
            */}
        </>
    )
}

function ActivityTimeline({projectId,autoload=false}) {

    const {userDD,getDDDataById} = useAppData();
    const [activityList,setActivityList] = useState(null);
    const [loading,setLoadingStatus] = useState(false);
    const {AppAlert} = useAlert();

    const getActivityList = () =>{
        setLoadingStatus(true);
        projectActivityServices.getActivityList(projectId).then(res=>{
            setActivityList(res.data);
            setLoadingStatus(true);
        }).catch(error=>{
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    useEffect(()=>{
        if(autoload){
            getActivityList();
        }
    },[])

    return (
    <>
        {!activityList && <button className='btn btn-outline-primary' onClick={getActivityList} >Get Activity List</button> }
        {!loading && activityList?.map(activity=>
            <div className='card my-2' key={activity.id}>
                {/*activity.activityType === 11 && <NotesDetails activity={activity} userDetails={getDDDataById(userDD,activity.userId)} /> */}
                {activity.activityType === 21 && <PoGenerated activity={activity} userDetails={getDDDataById(userDD,activity.userId)} /> }
                {activity.activityType === 22 && <PoUpdated activity={activity} userDetails={getDDDataById(userDD,activity.userId)} /> }

                
                {activity.activityType === 31 && <TaskCreated activity={activity} 
                    userDetails={getDDDataById(userDD,activity.userId)} 
                    />
                }

                {activity.activityType === 32 && <TaskUpdated activity={activity} 
                    userDetails={getDDDataById(userDD,activity.userId)} 
                    />
                }
                
                {activity.activityType === 33 && <TaskStatusUpdate activity={activity} 
                    userDetails={getDDDataById(userDD,activity.userId)} 
                />}

               
            </div>
        )}
        {loading &&
            <CircularProgress />
        }
    </>
  )
}

export default ActivityTimeline